module.exports = __webpack_public_path__ + "static/img/3.f27c3e8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/4/eng/3.png
// module id = nIci
// module chunks = 0